// extracted by mini-css-extract-plugin
export var container = "_kg-0";
export var segment = "_kg-2";
export var segmentActive = "_kg-3";
export var track = "_kg-1";